import DynamicCta from '@/components/DynamicPages/DynamicCta/DynamicCta';
import { ImageParagraph } from '@/components/DynamicPages/ImageParagraph/ImageParagraph';
import { Quote } from '@/components/DynamicPages/Quote/Quote';
import { TextParagraph } from '@/components/DynamicPages/TextParagraph/TextParagraph';
import { VideoLoopedParagraph } from '@/components/DynamicPages/VideoLoopedParagraph/VideoLoopedParagraph';
import { VideoPlayer } from '@/components/Elements/VideoPlayer/VideoPlayer';

import { PortfolioParagraphProps, getComponentForDynamicPage } from '@/helpers/getComponentForDynamicPage';

export interface PortfolioParagraphContentProps {
  id: string;
}

const components = new Map<string, React.ComponentType<PortfolioParagraphContentProps>>([
  ['portfolio-blocks.description', TextParagraph as React.ComponentType<PortfolioParagraphContentProps>],
  ['portfolio-blocks.resizable-image-title', ImageParagraph as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.blog-description', TextParagraph as React.ComponentType<PortfolioParagraphContentProps>],
  // Without title processing. For privacy and cookies page only.
  ['content-blocks.title-desc', TextParagraph as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.resizable-image-title', ImageParagraph as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.blog-quote', Quote as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.cta', DynamicCta as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.video-link', VideoPlayer as React.ComponentType<PortfolioParagraphContentProps>],
  ['blog-blocks.video-looped-title', VideoLoopedParagraph as React.ComponentType<PortfolioParagraphContentProps>],
]);

export const getParagraphForDynamicPage = (item: PortfolioParagraphProps, isGraySection: boolean) => {
  const itemProps = { ...item, isGraySection };

  return getComponentForDynamicPage(itemProps, components);
};
